// BANNER
export const TITLE = <div>Sales Engineer enablement</div>;

// INSTRUCTIONS
export const GOALS = "Learn how to plan and run technical live demos ad proofs of concept/proofs of value.";
export const HOW = "The training is free and includes both self-paced courses and instructor-led sessions.";
export const WHAT = "You must successfully complete Sales Specialist enablement and hold an active Associate Certification.";
export const REQUIREMENTS = " Sales specialist enablement must be successfully completed, and you must hold an active Associate Certification before starting Technical Sales enablement.";

// BADGE
const SALES_COVER_1 = "Introduction to Dynatrace";
const SALES_COVER_2 = "Master the art of discovery";
const SALES_COVER_3 = "Discover latest sales plays";
const SALES_COVER_4 = "Identify partner opportunities";
export const SALES_COVERS: String[] = [SALES_COVER_1, SALES_COVER_2, SALES_COVER_3, SALES_COVER_4];

const SALES_SPECIALIST_COVER_1 = "Further explore latest sales plays";
const SALES_SPECIALIST_COVER_2 = "Demo and PoC Dynatrace";
const SALES_SPECIALIST_COVER_3 = "Licensing and DPS explained";
const SALES_SPECIALIST_COVER_4 = "Competition and market analysis";
export const SALES_SPECIALIST_COVERS: String[] = [SALES_SPECIALIST_COVER_1, SALES_SPECIALIST_COVER_2, SALES_SPECIALIST_COVER_3, SALES_SPECIALIST_COVER_4];

const ASSOCIATE_COVER_1 = "Architecture and components";
const ASSOCIATE_COVER_2 = "Installation and configuration";
const ASSOCIATE_COVER_3 = "Hands-on labs";
const ASSOCIATE_COVER_4 = "Study quizzes";
export const ASSOCIATE_COVERS: String[] = [ASSOCIATE_COVER_1, ASSOCIATE_COVER_2, ASSOCIATE_COVER_3, ASSOCIATE_COVER_4];

const TECH_SALES_COVER_1 = "PoC/PoV best practices";
const TECH_SALES_COVER_2 = "Licensing and sizing";
const TECH_SALES_COVER_3 = "Hands-on labs";
const TECH_SALES_COVER_4 = "Study quizzes";
export const TECH_SALES_COVERS: String[] = [TECH_SALES_COVER_1, TECH_SALES_COVER_2, TECH_SALES_COVER_3, TECH_SALES_COVER_4];

// ACHIEVEMENTS
export const ACHIEVEMENTS = <div >
                        ·&nbsp;&nbsp; Upon completion of this training, you will have a solid understanding of how to deliver effective 
                        <br></br>
                        &nbsp;&nbsp;&nbsp;Dynatrace demos, calculate licensing requirements, troubleshoot common issues, and collaborate 
                        <br></br>
                        &nbsp;&nbsp;&nbsp;with your Dynatrace counterparts on PoCs and PoVs.
                        <br></br>
                        <br></br>
                        ·&nbsp;&nbsp; After passing a quiz, you will be awarded the Sales Engineer badge.
                    </div>;
// -- 


// FAQs
export const TITLE_ONE = "Dynatrace POC Planning template";
export const TITLE_TWO = "Dynatrace Business Impact Presentation template";
// export const TITLE_THREE = "What certifications are available for technical resources?";
// export const TITLE_FOUR = "Can I get the certification exam for free?";

export const SUB_TITLE_ONE = <div>Template to be used to prepare a Proof of Concept/Value. You can find it on our Collateral page or <a href="https://partners.dynatrace.com/#/collateral/8a998db288640aed01886d600f216465">here</a> </div>;
export const SUB_TITLE_TWO = <div>Template to be used to show the value to the customer, after a POC. You can find it on our Collateral page or <a href="https://partners.dynatrace.com/#/collateral/8a999322886e8e4d0188710a6fbf40e7">here</a> </div>;
// export const SUB_TITLE_THREE = "Our product certification program for Technical resources has 3 levels: Associate, Professional, and Master. More details on the different product certifications can be found on Dynatrace University.";
// export const SUB_TITLE_FOUR = "The technical exams are proctored by an external company that monitors trainees throughout the exam via their webcam. The price of the exam is related to the cost of this exam proctoring. You can get a free exam voucher by completing all labs during the Dynatrace Associate Certification Bootcamp or by attending events like Perform and Amplify. On top of that, Dynatrace will fund the cost of a repeat exam for trainees that got more than 68% on their first paid exam attempt.";

// --



